export default __webpack_public_path__ + "static/media/noProducts.50dd1790.png";